import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import moment from "jalali-moment";

import Layout from "../../../../component/Layout/Layout";
import Card from "../../../../component/Layout/theme/card";
import LogOut from "../../../../component/dashboard/user/logout/logout";
import PageChange from "../../../../component/pageChange";
import toast from "react-hot-toast";
import ThreeDScene from "../../../../component/3dEditor/ThreeDScene";


function EditEditorPage() {

    const params = useParams();
    var { t } = useTranslation()
    const { login, token } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [isModelLoad, setIsModelLoad] = useState(false);
    const [data, setData] = useState(null);
    const [stepPage, setStepPage] = useState(1)

    var durationConvert = 0;
    const [progressBar, setProgressBar] = useState(0);
    const [progressDone, setProgressDone] = useState([]) // MARKER, VIDEO

    // 3D Object step page 2
    const [scaleObject, setScaleObject] = useState(1.0)
    const [positionObject, setPositionObject] = useState({ x: 0, y: 0, z: 0 })
    const [rotateObject, setRotateObject] = useState({ x: 0, y: 0, z: 0 })
    const [pictureMarker, setPictureMarker] = useState(null)
    const [contentData, setContentData] = useState(null)


    const axiosInstance = axios.create({
        baseURL: `${process.env.REACT_APP_SERVER}`,
        timeout: 3000000 // only wait
    });

    const editStatusProcess = (title, status) => {
        setProgressDone(prevState => {
            return prevState.map((item) => {
                return item.title === title ? { title: title, status: status } : item
            })
        })
    }

    useEffect(() => {
        if (!login) {
            window.location.href = '/auth'
        } else {
            if (params.id != "null") {
                getAugmentedReality(params.id)
            } else {
                window.location.href = '/projects'
            }
        }
    }, [])

    async function getAugmentedReality(id) {
        await fetch(`${process.env.REACT_APP_SERVER}/api/nft/${id}`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        setData(result.data)
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }

    async function downloadFileToBlobWithProgress(imageUrl, onProgress) {
        try {
            const response = await axios.get(imageUrl, {
                responseType: 'blob',
                onDownloadProgress: progressEvent => {
                    if (onProgress) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        onProgress(percentCompleted);
                    }
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error downloading image:', error);
        }
    }


    useEffect(() => {
        if (data != null) {
            if (data.glb_model.length > params.row) {
                if (data.size_model.length > 0) {
                    setScaleObject(data.size_model[params.row].scale)
                    setPositionObject({
                        x: data.size_model[params.row].position.x,
                        y: data.size_model[params.row].position.y,
                        z: data.size_model[params.row].position.z
                    })
                    setRotateObject({
                        x: data.size_model[params.row].rotation.x,
                        y: data.size_model[params.row].rotation.y,
                        z: data.size_model[params.row].rotation.z
                    })    
                }
                setIsModelLoad(false)
                const urlImage = `${process.env.REACT_APP_SERVER}/uploads/${data.user.username}/image/${data.image[params.row]}`;
                const urlModel = `${process.env.REACT_APP_SERVER}/uploads/${data.user.username}/3d_model/${data.glb_model[params.row]}`;
                downloadFileToBlobWithProgress(urlImage, percentCompleted => {
                    setProgressBar(percentCompleted)
                }).then(blob => {
                    if (blob) {
                        setPictureMarker(blob)
                        downloadFileToBlobWithProgress(urlModel, percentCompleted => {
                            setProgressBar(percentCompleted)
                        }).then(blob => {
                            if (blob) {
                                setContentData(blob)
                                setIsModelLoad(true)
                                setProgressBar(0)
                            }
                        });
                    }
                });
            } else {
                window.location.href = `/projects/edit/${params.id}`
            }
        }
    }, [data])


    const handleButtonDisableContinue = () => {
        if (data != null) {
            return false
        }
        return true
    }


    const editAugmentedRealityMarker = async (id, index) => {

        setProgressBar(0)

        setProgressDone([{
            title: "احراز هویت",
            status: "DONE" // DONE, WAIT
        },
        {
            title: "آنالیز داده ها",
            status: "DONE" // DONE, WAIT
        },
        {
            title: "ارسال داده ها به سرور",
            status: "WAIT" // DONE, WAIT
        }])

        setStepPage(2)

        const formData = new FormData();

        formData.append("size_model", JSON.stringify({
            scale: scaleObject,
            position: {
                x: positionObject.x,
                y: positionObject.y,
                z: positionObject.z
            },
            rotation: {
                x: rotateObject.x,
                y: rotateObject.y,
                z: rotateObject.z
            }
        }));


        await axiosInstance.put(`/api/nft/editor/${id}?index=${index}`, formData, {
            headers: {
                Authorization: "ArNew " + token,
            },
            onUploadProgress: data => {
                var percentComplete = Math.ceil((100 * data.loaded) / data.total);
                setProgressBar(percentComplete)
                document.getElementById("progressBar").style.width = percentComplete.toString() + "%";
            }
        })
            .then(
                function (response) {
                    if (response.data.status === "success") {
                        editStatusProcess("ارسال داده ها به سرور", "DONE")
                        setData(response.data.data)
                        setStepPage(1)
                        toast.success("اطلاعات با موفقیت ذخیره شد");
                        // window.location.href = `/projects/edit/${params.id}`
                    } else {
                        window.location.href = `/projects/edit/${params.id}`
                        toast.error(response?.data?.msg);
                    }
                }
            ).catch(function ({ response }) {
                if (response.status !== 200) {
                    toast.error(response?.data?.msg)
                }
            });
    }

    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ?
                    isModelLoad
                        ?
                        (
                            <div className="p-5 mb-24 bg-white rounded-lg shadow-md">

                                {stepPage === 1 &&
                                    (
                                        <>
                                            <div className="h-[700px] mb-4">
                                                <ThreeDScene
                                                    scaleObject={scaleObject}
                                                    setScaleObject={setScaleObject}
                                                    positionObject={positionObject}
                                                    setPositionObject={setPositionObject}
                                                    rotateObject={rotateObject}
                                                    setRotateObject={setRotateObject}
                                                    marker={pictureMarker}
                                                    model={contentData}
                                                />
                                            </div>
                                            <div className="w-full flex justify-end">
                                                < button
                                                    disabled={handleButtonDisableContinue()}
                                                    className={` ${handleButtonDisableContinue() ? "bg-gray-100 text-gray-700 font-normal" : "bg-emerald-500 hover:shadow-lg text-white active:bg-emerald-600 font-bold"} uppercase text-lg px-6 py-3 rounded shadow  outline-none focus:outline-none ease-linear transition-all duration-150`}
                                                    type="button"
                                                    onClick={() => {
                                                        editAugmentedRealityMarker(params.id, params.row)
                                                    }}
                                                >
                                                    ویرایش
                                                </button >
                                            </div>
                                        </>
                                    )}

                                {stepPage === 2 &&
                                    <>
                                        <div className="m-auto w-1/2 lg:w-1/3 xl:w-1/3">
                                            <img className="free-image w-full object-cover rounded-lg" src={process.env.REACT_APP_ADDRESS + "/panel/upload-process.gif"} />
                                        </div>

                                        <div className="mt-8" role="status">
                                            <span className="p-2">درحال ایجاد واقعیت افزوده هستیم، این پردازش به حجم داده های شما بستگی دارد.</span>
                                            <div className="my-4">
                                                <div className="w-full mt-4 bg-gray-200 rounded-full dark:bg-gray-700">
                                                    <div id="progressBar" className="bg-green-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">{progressBar}%</div>
                                                </div>
                                            </div>
                                        </div>
                                        {progressDone.map((item, index) => {
                                            return (
                                                <div key={index} className="flex p-2">
                                                    {
                                                        item.status == "DONE" ?
                                                            (
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="#00ac8b" height="1.2em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                                                    <div className="px-2 font-normal text-base text-black">{item.title}</div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <svg className="inline text-gray-200 animate-spin fill-blue-600" height="1.2em" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                                    </svg>
                                                                    <span className="px-2 font-normal text-base text-black">{item.title}</span>
                                                                </>
                                                            )
                                                    }
                                                </div>
                                            )
                                        })}
                                    </>}
                            </div>
                        )
                        :
                        <div className="p-5 mb-24 bg-white rounded-lg shadow-md h-[700px] content-center">
                            <div className="bg-white rounded-xl shadow-sm overflow-hidden p-1">
                                <div className="relative h-6 flex items-center justify-center">
                                    <div className={`absolute top-0 bottom-0 left-0 rounded-lg w-[${progressBar}%] bg-blue-200`}></div>
                                    <div className="relative text-blue-900 font-medium text-sm">{progressBar}%</div>
                                </div>
                            </div>
                        </div>
                    :
                    (
                        <PageChange />
                    )}

            </Card >
        </>
    )
}

export default EditEditorPage